import {abilityFeature} from '../abilityFeature';
import {selectIsEditingCodeComponent} from '@packages/utilities/platform-selectors';

export const isEditingCodeComponent = abilityFeature({
  key: 'isEditingCodeComponent',
  isValid: function isEditingCodeComponentValid(state, expected) {
    const isEditing = selectIsEditingCodeComponent(state);
    return isEditing === expected;
  },
});
